import React from 'react';
import TopBanner from '../MainContents/TopBanner';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop';  
import CourseTable from './CourseTable.jsx'; 
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Button = styled.button`
    border: 2px solid #990820;
    background: #fdfdfd;
    padding: 10px;
    margin-left: 10px;
    font-weight: bold;
`;

const Pointer = styled.span`
    color: #fff;
    display: inline-block;
    background: linear-gradient(0deg, #990820 0%, #ba0020 100%);
    width: 25px;
    height: 25px;
    border-radius: 50%;
`;

const url = '/yotsutaninet/';

class Course extends React.Component {
    render() {
        return (
            <>
                <ScrollToTopOnMount />
                <TopBanner  
                    title="コース/時間割" 
                    text1="令和7年度 土佐塾・はりまやYT教室　前期時間割(3月4日～)" 
                    text2="※平日の補習や土曜日の個別指導は、無料となっています。" 
                    text3="※授業前の自主学習用教室として、新館2-1、新館2-2、新館3-1を開放しますので、ぜひ利用してください。" 
                    text4="※通塾の困難な生徒は、Zoomでの授業参加も可能です。" 
                />

                {/* 新小学3年生 YTクラス */}
                <CourseTable 
                    id="1"
                    heading="新小学３年生 新館3-2教室"
                    detailComment="※ 小３YTコースは、火曜日又は土曜日の週1日の選択コースとなります。"
                />

                {/* 新小学4年生 YTクラス */}
                <CourseTable 
                    id="2"
                    heading="新小学４年生 新館3-1教室"
                    detailComment="※ 四谷組分けテストは午後受験となり、当日の午後の個別補習はありません。小4ＹTは、テスト後に算数の解説授業(15:30～16:45)を行います。"
                />

                {/* 新小学5年生 YTクラス */}
                <CourseTable 
                    id="3"
                    heading="新小学５年生 新館2-2教室"
                    detailComment="※ 四谷組分けテストは午後受験となり、当日の午後の個別補習はありません。土佐塾テストは午前受験となり、午後から授業を行います。"
                />

                {/* 新小学6年生 YTクラス */}
                <CourseTable 
                    id="4"
                    heading="新小学６年生 新館2-1教室"
                    detailComment="※ 四谷組分けテストは午後受験となり、当日の午後の個別補習はありません。土佐塾テストは午前受験となり、午後から授業を行います。"
                />
            </>
        );
    }
}

export default Course;
